(function($) {
    var $exclude = '.news-wrapper h3';

    $("p, h1, h2:not(.title), h3, h4, h5, h6, .fade-in-text").not($exclude).each(function () {
        $(this).attr("data-aos", "fade-up");
    })

    $(window).load(function() {
        setTimeout(function() {
            AOS.refresh();
        }, 500);
    });


    /* Gravity forms */

    // Function to check if input/select elements have a value and apply the 'up' class
    function checkAndApplyUpClass() {
        $(".gfield .ginput_container:not(.ginput_complex) input, .gfield .ginput_container:not(.ginput_complex) textarea, .gfield select").each(function() {
            if ($(this).is('select')) {
                let selectedOption = $(this).find('option:selected');
                if (selectedOption.val() !== '' || selectedOption.hasClass('gf_placeholder')) {
                    $(this).closest('.gfield').addClass('up');
                } else {
                    $(this).closest('.gfield').removeClass('up');
                }
            } else if ($(this).val()) {
                $(this).closest('.gfield').addClass('up');
            } else {
                $(this).closest('.gfield').removeClass('up');
            }
        });

        $(".ginput_complex input").each(function() {
            if ($(this).val()) {
                $(this).parent().addClass('up');
            } else {
                $(this).parent().removeClass('up');
            }
        });


        $('.gform-body input').each(function() {
            if ($(this).val()) {
                $(this).parent().addClass('up');
            } else {
                $(this).parent().removeClass('up');
            }
        })
    }

// Initial load check
    $(document).ready(function() {
        checkAndApplyUpClass();
    });

// Event delegation for dynamically loaded fields
    $(document).on("focus focusout", ".gfield .ginput_container:not(.ginput_complex) input, .gfield .ginput_container:not(.ginput_complex) textarea, .gfield select", function() {
        if ($(this).is('select')) {
            if ($(this).find('option:selected').val()) {
                $(this).closest('.gfield').addClass('up');
            } else {
                $(this).closest('.gfield').removeClass('up');
            }
        } else if (!$(this).val()) {
            $(this).closest('.gfield').toggleClass('up');
        } else {
            $(this).closest('.gfield').addClass('up');
        }
    });

    $(document).on("focusin focusout", ".ginput_complex input", function() {
        if (!$(this).val()) {
            $(this).parent().toggleClass('up');
        } else {
            $(this).parent().addClass('up');
        }
    });

// Gravity Forms-specific hooks for page change and form submission
    $(document).on('gform_page_loaded gform_post_render', function() {
        checkAndApplyUpClass();
    });


    $(document).on('click', '.gform_next_button, .gform_previous_button, .gform_button', function () {
       setTimeout(function() {
           checkAndApplyUpClass();
       }, 750);
    });

    /* form stuff end */

    $( "select" ).on( "change", function() {
        $(this).parent().addClass('hide');
    });

    $("select").wrap('<div class="select-wrapper" />');


})( jQuery );


AOS.init({
    once: true
});
